import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Volume2, VolumeX } from 'lucide-react';
import { setSoundOn, soundOn, playPop } from './playPrefs';

/** Sound is OFF by default; this is the visible way to turn it on, and it says
 *  which state it is in rather than hiding behind an icon alone. */
export const SoundToggle = ({ testId = 'play-sound-toggle' }) => {
    const { t } = useTranslation();
    const [on, setOn] = useState(soundOn());
    const flip = () => {
        const next = !on;
        setSoundOn(next);
        setOn(next);
        if (next) playPop();            // a one-off sample so they hear what they chose
    };
    return (
        <button onClick={flip} data-testid={testId} aria-pressed={on}
            className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full border border-slate-200 px-3 text-xs font-semibold text-slate-600 transition-colors hover:border-emerald-400 hover:text-emerald-600 dark:border-slate-700 dark:text-slate-300">
            {on ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
            {on ? t('play.soundOn') : t('play.soundOff')}
        </button>
    );
};

export default SoundToggle;
